module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-28.8737a4eb.svg";